export const initAssets = ['brand/anim/skeleton.json']
export const splashAssets = [
  'animations/spine/splash-sc/skeleton.json',
  'animations/spine/splash/skeleton.json',
  'animations/spine/fullscreen/skeleton.json',
  'brand/images/brand.png',
  'atlases/splash-0.json',
  'atlases/base-0.json',
]
export const assets = [
  'animations/spine/buyFeatureBtn-sc/skeleton.json',
  'animations/spine/buyFeatureButton/skeleton.json',
  'animations/spine/byFeature/skeleton.json',
  'animations/spine/byFeature-sc/skeleton.json',
  'animations/spine/items/win/1/skeleton.json',
  'animations/spine/items/win/2/skeleton.json',
  'animations/spine/items/win/A/skeleton.json',
  'animations/spine/items/win/B/skeleton.json',
  'animations/spine/items/win/C/skeleton.json',
  'animations/spine/items/win/D/skeleton.json',
  'animations/spine/items/win/E/skeleton.json',
  'animations/spine/logo/skeleton.json',
  'animations/spine/logo-fs/skeleton.json',
  'animations/spine/logo-fs-sc/skeleton.json',
  'animations/spine/lowItems/skeleton.json',
  'animations/spine/mainSpine/skeleton.json',
  'animations/spine/mainSpine-sc/skeleton.json',
  'animations/spine/multi/skeleton.json',
  'animations/spine/select/skeleton.json',
  'animations/spine/total-win/skeleton.json',
  'animations/spine/win/skeleton.json',
  'bitmap/bitmap.xml',
  'atlases/main-0.json',
  'atlases/main-1.json',
  'atlases/main-2.json',
  'atlases/main-3.json',
  'atlases/main-4.json',
]
export const particle = ['atlases/particle-0.json']
